import { SET_GLOBAL_USERS_LIST, SET_ALL_USERS_LIST } from '../constants';

const initialState = {
  globalUsers: [],
  allUsers: [],
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_GLOBAL_USERS_LIST:
      return {
        ...state,
        globalUsers: action.payload,
      };
    case SET_ALL_USERS_LIST: {
      return {
        ...state,
        allUsers: action.payload,
      };
    }
    default:
      return state;
  }
};
